export class ProfileDetails_others {
	public experience: number;
	public areaOfInterest: Array<number> = new Array();
	public isHWProfessional: boolean;
    public expertId: number;
}
